<template>
  <a-modal
    :title="`新增${addType==='base'?'【基地仓】':'【卫星仓】'}调拨计划`"
    :width="1300"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
      <a-row>
        <a-col :md="6" :sm="24">
          <a-form-item label="物料编码" >
            <a-input v-decorator="['itemCode', { rules: [{ required: true, message: '' }] }]" allowClear />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="物料名称">
            <a-input v-decorator="['itemName']" allowClear />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="存放区域">
            <global-select
              v-decorator="['areaNameList']"
              selectType="selectMultiple"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
              :setParams="{ lookupType: 'INV_DEFAULT_AREA' }"
            />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-button @click="onSearch" type="primary">查询</a-button>
          <a-button type="primary" @click="batchImport" class="ml10">批量导入</a-button>
          <import-excel
            ref="importExcelRef"
            :downloadParams="downloadParams"
            :uploadParams="upload"
            :customizeUpload="true"
            :uploadAboutRequest="uploadAboutRequest"
            :setConfig="setConfig"
            @refresh="handleSearch" />
        </a-col>
      </a-row>
    </a-form>
    <!-- 表格 -->
    <ls-api-table
      ref="dataTableAdd"
      :columns="columns"
      :tableProps="tableProps"
      :multi-select="true"
      :selectedRows.sync="selectedRows"
      rowKey="serialNumber"
      :scroll="{ x: 3000, y: 210 }"
      @selectedRowChange="selectedRowChange"
    >
      <span slot="assignedQtyTitle">
        <i class="toRequired">*</i>本次调拨数量
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
        <div :key="item.dataIndex">
          <span v-if="item.type === 'inputNumber'">
            <a-input-number v-model="record[item.dataIndex]" :min="0" @change="inputNumberChange(record, item.dataIndex)" />
          </span>
          <span v-else-if="item.type === 'input'">
            <a-input v-model="record[item.dataIndex]" />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </ls-api-table>
  </a-modal>
</template>

<script>
import {
  apiInvWipAllocationPlanDispatchAddList,
  apiInvWipAllocationPlanQueryByBatch,
  apiInvWipAllocationPlanDispatchAddUpdate
} from '@/api/mes/scheduling-plan/allocation-plan'
import { generateLsTableResData } from '@/utils/util.js';
import ImportExcel from "@/components/ImportExcel/importExcel"
import moment from 'moment'
import { METHOD, requestSet } from '@/utils/request'

// 表单字段
export default {
  props: {},
  components: {
    ImportExcel
  },
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiInvWipAllocationPlanDispatchAddList, true),
        pageCurrent: true
      },
      addType: '', // 区分是基地仓新增，还是卫星仓新增
      planTypParam: { 'base': 2, 'satellite': 4 }, // planType根据addType来设置，2:基地仓，4:卫星仓
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/inv/invWipAllocationPlan/jdcImport' // 上传的地址
      },
      uploadAboutRequest: {
        requestApi: '',
        errFileName: '新增调拨导入文件.xlsx'
      },
      timestamp: 0, // 时间戳标识
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'inv/invWipAllocationPlan/downLoadJdcImportTemplate',
        name: `新增调拨导入模板下载_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      setConfig: {
        setTip: '导入完成，导入情况可看反馈表'
      },
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '安全库存水位',
          dataIndex: 'safetyStockLevel',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '当前订单满足率',
          dataIndex: 'currentSatisfyRate',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '当前可用数',
          dataIndex: 'currentAvailableQty',
          align: 'center'
        },
        {
          title: '当天欠货数',
          dataIndex: 'backlog1',
          align: 'center'
        },
        {
          title: '5天欠货数',
          dataIndex: 'backlog5',
          align: 'center'
        },
        {
          title: '10天欠货数',
          dataIndex: 'backlog10',
          align: 'center'
        },
        {
          title: '15天欠货数',
          dataIndex: 'backlog15',
          align: 'center'
        },
        {
          title: '20天欠货数',
          dataIndex: 'backlog20',
          align: 'center'
        },
        {
          title: '25天欠货数',
          dataIndex: 'backlog25',
          align: 'center'
        },
        {
          title: '30天欠货数',
          dataIndex: 'backlog30',
          align: 'center'
        },
        {
          title: '可调拨数量',
          dataIndex: 'allocableQty',
          align: 'center'
        },
        {
          title: '本次调拨数量',
          dataIndex: 'assignedQty',
          scopedSlots: { customRender: 'assignedQty', title: "assignedQtyTitle" },
          align: 'center',
          type: "inputNumber"
        },
        {
          title: '托盘标准容量',
          dataIndex: 'palletStandardQty',
          align: 'center'
        },
        {
          title: '存放区域',
          dataIndex: 'areaName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '调拨到仓日期',
          dataIndex: 'deliveryDate',
          align: 'center'
        },
        {
          title: '调拨后订单满足率',
          dataIndex: 'assignedSatisfyRate',
          align: 'center'
        },
        {
          title: '客审未货审订单',
          dataIndex: 'orderQty',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remarks',
          scopedSlots: { customRender: 'remarks' },
          align: 'center',
          type: "input"
        }
      ],
      // 查询参数
      form: this.$form.createForm(this),
      // 表格多选
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {

  },
  methods: {
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 查询导入的数据
    handleSearch(val) {
      if(this.timestamp === 0) return
      this.tableProps = {
        requestApi: generateLsTableResData(apiInvWipAllocationPlanQueryByBatch, true),
        pageCurrent: true
      }
      const self = this
      setTimeout(() => {
        self.$refs.dataTableAdd.searchParams = { batchNo: self.timestamp, planType: this.planTypParam[this.addType] };
        self.$refs.dataTableAdd.getData();
      }, 200)
    },
    // 批量导入
    batchImport() {
      this.timestamp = 0
      // 导入请求，带参数
      const apiImportPlanOrder = (params) => {
        this.timestamp = new Date().getTime()
        return requestSet(`/inv/invWipAllocationPlan/jdcImport?batchNo=${this.timestamp}&planType=${this.planTypParam[this.addType]}`, METHOD.POST, params, { responseType: "blob" });
      }
      this.uploadAboutRequest.requestApi = apiImportPlanOrder;
      this.$refs.importExcelRef.show()
    },
    // 表单搜索
    onSearch () {
      this.tableProps = {
        requestApi: generateLsTableResData(apiInvWipAllocationPlanDispatchAddList, true),
        pageCurrent: true
      }
      const self = this
      setTimeout(() => {
        self.searchFun();
      }, 200)
    },
    // 搜索
    searchFun() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = this.form.getFieldsValue();
          params = { ...params, planType: this.planTypParam[this.addType] }
          this.$refs.dataTableAdd.searchParams = params;
          this.$refs.dataTableAdd.getData();
        } else {
          this.$message.warning('请检查必填项！')
        }
      });
    },
    show (type) {
      this.addType = type
      this.visible = true
      // this.$nextTick(() => {
      //   this.onSearch()
      // })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.selectedRows.length; i++) {
        if (!this.selectedRows[i].assignedQty) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
        if (this.selectedRows[i].assignedQty > this.selectedRows[i].allocableQty) {
          this.$message.warning('本次调拨数量不能大于可调拨数量')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true

      apiInvWipAllocationPlanDispatchAddUpdate(this.selectedRows).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    inputNumberChange (record, dataIndex) {
      if (dataIndex === "assignedQty") {
        const num = (Number(record.assignedQty) + Number(record.currentAvailableQty)) / Number(record.orderQty)
        const bln = Number.isFinite(num)
        const num2 = bln ? `${this.$parseFloatToFixed(num, 2)}%` : 0
        record.assignedSatisfyRate = num2
      }
    },
    // 表单重置
    reset () {
      this.form.resetFields()
      this.$refs.dataTableAdd.myDataSource = []
      this.$refs.dataTableAdd.myPagination.total = 0
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 170px !important;
}
/deep/.ant-modal-body{
  max-height: 400px;
  overflow-y: scroll;
}
/deep/ .ant-form-item-with-help{
  margin-bottom: 0;
}
/deep/ .ant-form-explain{
  height: 0;
  min-height: 0;
}
</style>
